import axios from "axios";
const Instance = axios.create({
  baseURL: "https://anwarapi.erp-softgroup.link",
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.token
  }
});
export default Instance;
